import axios from 'utils/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

const urls = {
  createProductService: '/product',
  allProductAndServices: '/product/getAll',
  getProductDetails: '/product/product-detail',
  updateProductImages: '/product/uploadProductImages',
  duplicateProductToStores: '/product/duplicateProductToStores',
  getProductServicesByStoreId: '/product/store'
};

export const createProductServiceApi = createAsyncThunk(
  'serviceplug/createProductServiceApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.createProductService}`,
        method: 'post',
        data: params
      });
      const data = await response.data;
      return data?.result;
    } catch (err) {
      // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const updateProductServiceApi = createAsyncThunk(
  'serviceplug/updateProductServiceApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.createProductService}/${params.productId}`,
        method: 'put',
        data: params
      });
      const data = await response.data;
      return data?.result;
    } catch (err) {
      // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const deleteProductServiceApi = createAsyncThunk(
  'serviceplug/deleteProductServiceApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.createProductService}/${params.productId}`,
        method: 'delete'
      });
      const data = await response.data;
      return data?.result;
    } catch (err) {
      // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const uploadProductImagesApi = createAsyncThunk('user/uploadProductImagesApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.updateProductImages}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getAllProductAndServicesApi = createAsyncThunk(
  'serviceplug/getAllProductAndServicesApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.get(urls.allProductAndServices, { params });
      if (response.data?.result) {
        return response.data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong with this');
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getProductAndServiceDetailsApi = createAsyncThunk(
  'serviceplug/getProductAndServiceDetailsApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.get(`${urls.getProductDetails}/${params.productId}`);
      if (response.data?.result) {
        return response.data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong with this');
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const duplicateProductToStoresApi = createAsyncThunk(
  'serviceplug/duplicateProductToStoresApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.duplicateProductToStores}`,
        method: 'post',
        data: params
      });
      const data = await response.data;
      thunkApi.dispatch(getAllProductAndServicesApi());
      return data?.result;
    } catch (err) {
      // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const getProductServicesByStoreIdApi = createAsyncThunk(
  'serviceplug/getProductServicesByStoreIdApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.get(`${urls.getProductServicesByStoreId}/${params.storeId}`);
      if (response.data?.result) {
        return response.data?.result;
      }
      return thunkApi.rejectWithValue('Something went wrong with this');
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
